/** @format */

import { createSlice } from '@reduxjs/toolkit';
import axios from 'src/utils/axios';
import { ENDPOINTS } from 'src/constants';
import type { CmsPageContent } from 'src/types';

const initialState = {
  privateContentInfo: {} as Record<string, CmsPageContent>,
  loading: false,
  error: null as unknown
};

const slice = createSlice({
  name: 'privateContent',
  initialState,
  reducers: {
    getPrivateContent(state) {
      state.loading = true;
      state.error = null;
    },
    getPrivateContentSuccess(state, action) {
      const { id, data } = action.payload;
      state.privateContentInfo[String(id)] = data;
      state.loading = false;
    },
    getPrivateContentFailure(state, action) {
      const { error } = action.payload;
      state.error = error;
      state.loading = false;
    }
  }
});

export const reducer = slice.reducer;

export const getPrivateContentInfo =
  (id: string | number, onSuccess: (data: unknown) => void, onFailure?: (err: unknown) => void) =>
  async dispatch => {
    const { getPrivateContent, getPrivateContentSuccess, getPrivateContentFailure } = slice.actions;

    try {
      dispatch(getPrivateContent());
      const response = await axios.get<CmsPageContent>(`${ENDPOINTS.GET_PRIVATE_CONTENT_INFO_ENDPOINT}/${id}`);
      dispatch(getPrivateContentSuccess({ id, data: response.data }));
      onSuccess(response.data);
    } catch (err) {
      dispatch(getPrivateContentFailure(err));
      onFailure?.(err);
    }
  };

export default slice;
